import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { Configuration } from '../models/configuration';
import { Subject, Observable } from 'rxjs';  

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private _storage: Storage | null = null;
  public configuration: Configuration | null = null;
  private _isReady = false;
  private _readySubject = new Subject<boolean>();

  public _configurationUpdated$ = new Subject<Configuration>();
  public configurationUpdated$ = this._configurationUpdated$.asObservable();
  public ready$ = this._readySubject.asObservable();

  constructor(private storage: Storage) {
    this.init();
  }

  async init() {
    try {
      this._storage = await this.storage.create();
      this._isReady = true;
      this._readySubject.next(true);

      this.get('configuration').then(
        data => {
          this.configuration = data;
          if(this.configuration == null)
            this.configuration = new Configuration();
          this._configurationUpdated$.next(this.configuration);
        },
        error => {
          this.configuration = new Configuration();
          this._configurationUpdated$.next(this.configuration);
        });
    } catch (error) {
      console.error('Storage initialization failed:', error);
      this._isReady = false;
      this._readySubject.next(false);
    }
  }

  public isReady(): boolean {
    return this._isReady;
  }

  public async waitForReady(): Promise<boolean> {
    if (this._isReady) {
      return Promise.resolve(true);
    }
    
    return new Promise((resolve) => {
      const subscription = this.ready$.subscribe((ready) => {
        if (ready) {
          subscription.unsubscribe();
          resolve(true);
        }
      });
      
      // Timeout après 10 secondes
      setTimeout(() => {
        subscription.unsubscribe();
        resolve(false);
      }, 10000);
    });
  }
  
  public set(key: string, value: any) {
    if(this._storage != null)
      this._storage.set(key, value);
    else
      console.log('_storage is null');
  }

  public get(key: string) {
  return this.storage.get(key).then(token => {
        //console.log('Got token', token);
        return token;
    }, error => console.error(error));
  }

  public remove(key: string) {
    if(this._storage != null)
      return this._storage.remove(key);
    else {
      console.log('_storage is null');
      return null;
    }
  }

  public saveConfiguration() {
    if(this.configuration != null) {
      this.set('configuration', this.configuration);
      this._configurationUpdated$.next(this.configuration);
    }
  }
}
